import useAccounting from 'context/accounting-context/hook';
import PayoutsTableRow from './PayoutsTableRow';
import PayoutsTableFillerRow from './PayoutsTableFillerRow';

const PayoutsTableBody = () => {
  const { payouts } = useAccounting();
  return (
    <tbody>
      {payouts.map(item => (
        <PayoutsTableRow key={item.id} payoutData={item} />
      ))}
      <PayoutsTableFillerRow />
    </tbody>
  );
};

export default PayoutsTableBody;